import { memo, useRef, useState } from 'react';
import { addCommas } from '@persian-tools/persian-tools';
import PriceRangeMobile from './priceRangeMobile/PriceRangeMobile';
import useSearchParams from '@/components/search/hooks/useSearchParams';
import useDevice from '@/hooks/useDevice';
import FilterChips from '../reusabe/filterChips/FilterChips';
import Drawer from '@/components/UI/drawer/Drawer';
import useDrawer from '@/hooks/useDrawer';
import Box from '@/components/UI/box/Box';
import styles from './PriceRange.module.scss';
import Menu from '@/components/UI/menu/Menu';
const PriceRange = () => {
  const {
    setQuery,
    queries
  } = useSearchParams();
  const isMidTerm = queries?.mid_term;
  const [min, max] = [100_000, isMidTerm ? 300_000_000 : 30_0000_000];
  const [range, setRange] = useState<number[]>([Number(queries?.min_price) * 1000 || min, Number(queries?.max_price) * 1000 || max]);
  const {
    drawerOpen,
    drawerClose,
    isDrawerOpen
  } = useDrawer();
  const open = isDrawerOpen('PRICE_RANGE');
  const {
    isMobile
  } = useDevice();
  const closeRef = useRef<any>(null);
  const handleClick = () => {
    if (open) {
      drawerClose();
    } else {
      drawerOpen('PRICE_RANGE');
    }
  };
  const handleClose = () => {
    setRange([Number(queries?.min_price) * 1000 || min, Number(queries?.max_price) * 1000 || max]);
    drawerClose();
  };
  const submitData = (nextRange?: number[]) => {
    const currentRange = nextRange ?? range;
    const priceLimit: {
      min_price: number | undefined;
      max_price: number | undefined;
    } = {
      min_price: undefined,
      max_price: undefined
    };
    if (currentRange[0] !== min) {
      priceLimit.min_price = currentRange[0] / 1000;
    }
    if (currentRange[1] !== max) {
      priceLimit.max_price = currentRange[1] / 1000;
    }
    setRange(currentRange);
    setQuery(priceLimit);
  };
  const handleClean = e => {
    e.stopPropagation();
    setRange([min, max]);
    setQuery({
      min_price: undefined,
      max_price: undefined
    });
  };
  const checkIsActive = () => {
    if (!!queries.min_price && +queries.min_price * 1000 !== min) {
      return true;
    }
    if (!!queries.max_price && +queries.max_price * 1000 !== max) {
      return true;
    }
    return false;
  };
  const buttonText = checkIsActive() ? `${queries.min_price ? ' از ' + addCommas(+queries.min_price * 1000) : ''} ${queries.max_price ? ' تا ' + addCommas(+queries.max_price * 1000) : ''}` : isMidTerm ? `قیمت ${queries?.checkin && queries?.checkout ? 'کل' : ''}` : 'قیمت برای هر شب';
  return <Box className={styles['filter-item-wrapper']} data-sentry-element="Box" data-sentry-component="PriceRange" data-sentry-source-file="PriceRange.tsx">
      <FilterChips type="secondary" checked={checkIsActive()} handleClick={handleClick} handleClean={handleClean} label={buttonText} endIcon name="price_filter" id="price-range-chips" data-sentry-element="FilterChips" data-sentry-source-file="PriceRange.tsx" />

      {!isMobile ? <Menu ref={closeRef} id="price-range" open={open} handleClose={drawerClose} className={styles['filter-item-container']} menuButtonId="price-range-chips" handleAction={() => {
      setRange([Number(queries?.min_price) * 1000 || min, Number(queries?.max_price) * 1000 || max]);
    }}>
          <PriceRangeMobile value={range} onClose={handleClose} setValue={setRange} step={100_000} min={min} max={max} submitData={submitData} resetFilter={handleClean} hasPriceRangeFilter={checkIsActive()} />
        </Menu> : <Drawer open={isDrawerOpen('PRICE_RANGE')} onClose={handleClose}>
          <PriceRangeMobile value={range} onClose={handleClose} setValue={setRange} step={100_000} min={min} max={max} submitData={submitData} resetFilter={handleClean} hasPriceRangeFilter={checkIsActive()} />
        </Drawer>}
    </Box>;
};
export default memo(PriceRange);